import Icon from "@bokio/designsystem/components/Icon/Icon";
import { mergeClassNames } from "@bokio/utils/classes";

import { Tooltip } from "./Tooltip";

import type { TooltipPlacement } from "./tooltipUtils";
import type { IconColor, IconSize } from "@bokio/designsystem/components/Icon/Icon";
import type { ReactNode } from "react";

export interface InfoTooltipProps {
	contentGenerator: ReactNode | (() => ReactNode);
	wrapperClassName?: string;
	tooltipClassName?: string;
	color?: "black" | "white";
	size?: IconSize;
	placement?: TooltipPlacement;
	heading?: string;
	className?: string;
	arrowOffsetClassName?: string;
	iconColor?: IconColor;
	type?: "filled" | "outline";
	testId?: string;
	stopPropagation?: boolean;
}

export const InfoTooltip = (props: InfoTooltipProps) => (
	<Tooltip {...props}>
		<Icon
			name={props.type === "outline" ? "ic_info" : "info"}
			className={mergeClassNames(!props.iconColor && props.className)}
			color={props.iconColor || "blue"}
			size={props.size || "16"}
			testId={props.testId}
		/>
	</Tooltip>
);
